module.exports = __webpack_public_path__ + "static/media/mazda-logo-dark.69f635bb.svg";